import isNil from "ramda/src/isNil";
export const bypass = (fn) => (data) => {
  fn(data);
  return data;
};

export const vkkv = (fn) => (value, key) => fn(key, value);

export function semicolonSplit(mixed) {
  if (!mixed) return [];
  const STRIP_SURROUND = /^[ ;]*|[ ;]*$/g;
  const STRIP_BETWEEN = /\s*;\s*/g;
  const NORMALIZE_SPACES = /\s+/g;
  const NORMALIZE_SEMICOLONS = /;+/g;

  const output = mixed
    .replace(STRIP_SURROUND, "")
    .replace(STRIP_BETWEEN, ";")
    .replace(NORMALIZE_SPACES, " ")
    .replace(NORMALIZE_SEMICOLONS, ";");

  return output ? output.split(";") : [];
}

export function safe(v) {
  return isNil(v) ? "" : v;
}

export function loadScript(url, callback) {
  let div = document.createElement("div");
  div.setAttribute("id", "chtflt");
  div.setAttribute("style", "display:none");

  let script1 = document.createElement("script");
  script1.type = "text/javascript";
  script1.appendChild(
    document.createTextNode(
      'var chtfltUrl = "https://sac-algartelecom.ascbrazil.com.br/Chat/id/chatasc1"; var chtfltTitulo = "Suporte Algar Telecom"; var chtfltVarComplementar=""; var chtfltTema = "skin-green"; var chtfltLanguage="pt-BR"; var chtfltRobo = "0"; var chtfltUrlImg="https://sac-algartelecom.ascbrazil.com.br/public/imagens/uploads/chat/chat_imagem_flutuante_20210630143523.png"'
    )
  );

  let script2 = document.createElement("script");
  script2.type = "text/javascript";
  script2.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/chat/new/chatInline.js";

  let link = document.createElement("link");
  link.setAttribute("rel", "stylesheet");
  link.type = "text/css";
  link.setAttribute(
    "href",
    "https://sac-algartelecom.ascbrazil.com.br/public/chat/new/chatInline.css"
  );

  div.appendChild(script1);
  div.appendChild(script2);
  div.appendChild(link);

  div.onload = callback;
  document.getElementsByTagName("body")[0].appendChild(div);
}

export function loadChatCorp(url, callback) {
  let div = document.createElement("div");
  div.setAttribute("id", "chtflt");
  div.setAttribute("style", "display:none");

  let script1 = document.createElement("script");
  script1.type = "text/javascript";
  script1.appendChild(
    document.createTextNode(
      'var chtfltUrl = "https://sac-mpealgartelecom.ascbrazil.com.br/Chat/id/chatalgar"; var chtfltTitulo = ""; var chtfltVarComplementar=""; var chtfltTema = "skin-green"; var chtfltLanguage="pt-BR"; var chtfltRobo = "0"; var chtfltUrlImg="https://sac-algartelecom.ascbrazil.com.br/public/imagens/uploads/chat/chat_imagem_flutuante_20190412162242.png";'
    )
  );

  let script2 = document.createElement("script");
  script2.type = "text/javascript";
  script2.src =
    "https://sac-mpealgartelecom.ascbrazil.com.br/public/chat/new/chatInline.js";

  let link = document.createElement("link");
  link.setAttribute("rel", "stylesheet");
  link.type = "text/css";
  // link.setAttribute("href", "https://sac-mpealgartelecom.ascbrazil.com.br/public/chat/new/chatInline.css")
  link.setAttribute(
    "href",
    "https://portal-algartelecom-files.s3.amazonaws.com/chatb2b/chatB2B.css"
  );

  div.appendChild(script1);
  div.appendChild(script2);
  div.appendChild(link);
  div.onload = callback;
  document.getElementsByTagName("body")[0].appendChild(div);
}

export const loadStandartChat = () => {
  const div = document.createElement("div");
  div.setAttribute("id", "chtflt");
  div.setAttribute("style", "display:none");

  const scriptAscJquery = document.createElement("script");
  scriptAscJquery.type = "text/javascript";
  scriptAscJquery.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/js/jquery-2.0.3.min.js";

  const scriptAscCore = document.createElement("script");
  scriptAscCore.type = "text/javascript";
  scriptAscCore.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/js/Core.min.js";

  const scriptAscBasil = document.createElement("script");
  scriptAscBasil.type = "text/javascript";
  scriptAscBasil.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/js/basil/src/basil.js";

  const scriptAscBasilList = document.createElement("script");
  scriptAscBasilList.type = "text/javascript";
  scriptAscBasilList.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/js/basil/src/basil.list.js";

  const scriptAscBasilSet = document.createElement("script");
  scriptAscBasilSet.type = "text/javascript";
  scriptAscBasilSet.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/js/basil/src/basil.set.js";

  const scriptAscSocket = document.createElement("script");
  scriptAscSocket.type = "text/javascript";
  scriptAscSocket.src =
    "https://sac-algartelecom.ascbrazil.com.br/Painel/public/js/templates/socket.io.js";

  const scriptAscChatFlut = document.createElement("script");
  scriptAscChatFlut.type = "text/javascript";
  scriptAscChatFlut.src =
    "https://sac-algartelecom.ascbrazil.com.br/public/chat/new/18/chatFlut.min.js";

  const scriptAscConfig = document.createElement("script");
  scriptAscConfig.type = "text/javascript";
  scriptAscConfig.appendChild(
    document.createTextNode(`
    var chtfltUrl = "https://sac-algartelecom.ascbrazil.com.br/Chat/id/cancelado"; 
    var chtfltWidthLogin = ""; 
    var chtfltHeightLogin = "500"; 
    var chtfltWidth = ""; 
    var chtfltHeight = "500"; 
    var chtfltWidthPesquisa = ""; 
    var chtfltHeightPesquisa = "500"; 
    var chtfltTitulo = ""; 
    var chtfltVarComplementar=""; 
    var chtfltTema = "tema_98c41554234499231";
    var chtfltLanguage="pt-BR"; 
    var chtfltRobo = "1"; 
    var chtfltUrlImg="";
  `)
  );

  const linkCss = document.createElement("link");
  linkCss.setAttribute("rel", "stylesheet");
  linkCss.type = "text/css";
  linkCss.setAttribute(
    "href",
    "https://portal-algartelecom-files.s3.sa-east-1.amazonaws.com/chatb2b/chat_v2.css"
  );

  div.appendChild(scriptAscJquery);
  div.appendChild(scriptAscCore);
  div.appendChild(scriptAscBasil);
  div.appendChild(scriptAscBasilList);
  div.appendChild(scriptAscBasilSet);
  div.appendChild(scriptAscSocket);
  div.appendChild(scriptAscConfig);
  div.appendChild(scriptAscSocket);
  div.appendChild(linkCss);
  div.appendChild(scriptAscChatFlut);

  document.getElementsByTagName("body")[0].appendChild(div);
};

export const isDevelopment = () => {
  return process.env.NODE_ENV === "development";
};



// WEBPACK FOOTER //
// ./src/services/utils/fn.js